import { Link } from "react-router-dom";

export default function PartnerWhatsappNeedsAttention({ items = [], emptyMessage }) {
  if (!items.length) {
    return <p className="muted">{emptyMessage}</p>;
  }

  return (
    <ul className="partner-attention-list partner-whatsapp-attention">
      {items.map((item) => (
        <li key={item.id}>
          <span
            className={`partner-whatsapp-attention__badge partner-whatsapp-attention__badge--${item.severity || "warning"}`}
          >
            {item.severity === "critical" ? "Critical" : "Attention"}
          </span>
          <span>{item.message || item.label}</span>
          {item.route ? (
            <Link to={item.route}>Review</Link>
          ) : item.comingSoon ? (
            <span className="partner-whatsapp-attention__soon muted">Conversation list coming next.</span>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
